/**
 * Main UOC2Future Application Script
 */


/**
 * Boostrap dependencies
 * NOTE: Popover, dropdowns and tooltip require popper and util modules. Popovers also require tooltip
 */
import 'popper.js';
//import 'bootstrap';
import 'bootstrap/js/dist/util';
import 'bootstrap/js/dist/alert';
//import 'bootstrap/js/dist/button';
import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/dropdown';
import 'bootstrap/js/dist/modal';
import 'bootstrap/js/dist/popover';
//import 'bootstrap/js/dist/scrollspy';
//import 'bootstrap/js/dist/tab';
//import 'bootstrap/js/dist/toast';
import 'bootstrap/js/dist/tooltip';


/**
 * Another Dependencies
 */
import objectFitImages from 'object-fit-images';      // object-fit polyfill
//import screenfull from 'screenfull';                  // fullscreen api wrapper
import 'select2';                                     // Select2
import fancybox from "@fancyapps/fancybox";           // Fancybox

import Swiper, {
  Keyboard,
  Navigation,
  Pagination,
  Autoplay,
  A11y,
  EffectFade
} from 'swiper';                                      // Swipper


/**
 * App modules
 */
import { debounce, isMobile, goTo } from './modules/utils.js';


( function ( $, themeData ) {

  'use strict';

  // Expose jquery to modules
  window.jQuery = $;
  window.$ = $;

  // Aux constants
  const $body = $( 'body' );
  const $win = $( window );
  const $doc = $( document );
  const $goup = $( '.sticky-scroll' );
  const breakpoint = 768;
  const page = document.getElementById( 'page' );

  // Aux variables
  let ww = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;


  // Swiper default settings
  let sliderSettings = {
    modules: [
      Keyboard,
      Navigation,
      Pagination,
      Autoplay,
      A11y,
      EffectFade
    ],
    autoplay: {
      delay: 7000,
      disableOnInteraction: false
    },
    loop: true,
    speed: 700,
    watchOverflow: true,
    //grabCursor: true,
    keyboard: {
      enabled: true,
      onlyInViewport: true,
    },
    a11y: {
      enabled: true,
      prevSlideMessage: themeData.t.prevSlideMessage,
      nextSlideMessage: themeData.t.nextSlideMessage,
      firstSlideMessage: themeData.t.firstSlideMessage,
      lastSlideMessage: themeData.t.lastSlideMessage,
      paginationBulletMessage: themeData.t.paginationBulletMessage,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: '.swiper-pagination',
      dynamicBullets: true,
      dynamicMainBullets: 9,
      clickable: true
    },
  };


  // Fancybox default settings
  let fancySettings = {
    hash: false,
    loop: true,
    animationEffect: "fade",
    buttons: [
      //"zoom",
      "slideShow",
      "fullScreen",
      "thumbs",
      "close"
    ],
    lang: themeData.lang,
    i18n: {}
  };

  fancySettings.i18n[ themeData.lang ] = {
    CLOSE: themeData.t.closeMessage,
    NEXT: themeData.t.nextSlideMessage,
    PREV: themeData.t.prevSlideMessage,
    ERROR: themeData.t.errorMessage,
    PLAY_START: themeData.t.playStartMessage,
    PLAY_STOP: themeData.t.playStopMessage,
    FULL_SCREEN: themeData.t.fullScreenMessage,
    THUMBS: themeData.t.thumbsMessage
  };

  /**
   * On resize event handler (debounced)
   */
  const onResize = debounce( () => {
    ww = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    if ( ww > breakpoint ) {
      $body.removeClass( 'device-sm' );
    } else {
      $body.addClass( 'device-sm' );
    }

    /*$( ".img-cover.fade.show" ).each( function () {
      fitThumb( this );
    } );*/

  }, 50, false )


  /**
   * On scroll event handler (debounced)
   */
  const onScroll = debounce( () => {

    const top = $win.scrollTop();

    /*if ( page ) {
      $body.toggleClass( 'is-sticky', page.offsetTop < top );
    }*/

    $body.toggleClass( 'is-sticky', top > 0 );

    if ( top > 340 ) {
      $goup.removeClass( 'off' );
    } else {
      $goup.addClass( 'off' );
    }

  }, 10, true )


  /**
   * Append external
   * @param {object} item dom element
   */
  const appendExternal = function ( item ) {
    var $item = $( item );
    if ( !$item.find( '.sr-only' ).length ) {
      $item.append( `<span class="sr-only">${themeData.t.externalLink}</span>` );
    }
  }

  /**
   * Sum fixed elements to offset
   */
  const getOffset = function ( offset ) {
    const $header = $( '.site-header' );
    const $menu = $( '.site-menu' );
    offset = offset || 0;

    if ( $header.length ) {
      offset += $header.height();
    }

    if ( $menu.length && !$body.hasClass( 'device-sm' ) ) {
      offset += $menu.height();
    }

    if ( $( 'body' ).hasClass( 'admin-bar' ) ) {
      offset += $( '#wpadminbar' ).height();
    }

    return offset;
  }


  /**
   * Toggle offcanvvas menu
   */
  const toggleOffCanvas = function () {
    const $overlay = $( '.offcanvas-overlay' );
    if ( $body.hasClass( 'offcanvas-open' ) ) {
      setTimeout( function () { $overlay.addClass( 'closed' ) }, 300 );
    } else {
      $overlay.removeClass( 'closed' );
    }
    $body.toggleClass( "offcanvas-open" );
    if ( $body.hasClass( 'device-touch' ) ) {
      $body.toggleClass( "overflow-hidden" );
    }
  }

  /**
   * Setup menu
   */
  const setupMenu = function () {

    // Offcanvas menu

    $( ".offcanvas-trigger" ).on( 'click', function ( ev ) {
      ev.preventDefault();
      toggleOffCanvas();
      return false;
    } );

    $( ".offcanvas-overlay" ).on( 'click', function () {
      if ( $body.hasClass( 'offcanvas-open' ) ) {
        toggleOffCanvas();
      }
    } );

    /*
    $doc.on('click', function(ev) {
      if (!$(ev.target).closest('.offcanvas').length) { 
        $body.toggleClass('offcanvas-open', false);
      }
    });
    */

    // External links
    const $external = $( '.site-menu ul.navbar-nav a[target=_blank], ul.footer-list a[target=_blank], ul.footer-text a[target=_blank]' );
    $external.each( function () {
      appendExternal( this );
    } )

  }


  /**
   * Setup generic events
   */
  const setupEvents = function () {

    // Resize event
    $win.on( 'resize', function () {
      onResize();
    } );

    // Scroll event
    $win.on( 'scroll', function () {
      onScroll();
    } );

    // Go to top scroll
    $goup.on( 'click', function () {
      window.scrollTo( { top: 0, behavior: 'smooth' } );
      return false;
    } );

    // Fullscreen
    /*$( '.btn--fullscreen' ).on( 'click', function () {
      if ( screenfull.isEnabled ) {
        const element = $( this ).closest( '.section--fullscreen' )[ 0 ]; // Get DOM element from jQuery collection
        screenfull.toggle( element, { navigationUI: 'hide' } );
      }
      return false;
    } );*/

    // Tooltips
    $( '[data-toggle="tooltip"]' ).tooltip( {
      animated: 'fade'
    } );

    // Popovers
    $( '[data-toggle="popover"]' ).popover();

    // Unavailable
    $doc.on( 'click', 'a.unavailable', function ( e ) {
      e.preventDefault();
    } );

    // Search collapse focus
    $( '.search-collapse' ).on( 'shown.bs.collapse', function () {
      $( this ).find( 'input[name="s"]' ).trigger( 'focus' );
    } );


    // Modal embed videos
    $doc.on( 'show.bs.modal', '.modal-oembed', function ( e ) {
      var $button = $( e.relatedTarget );
      var $modal = $( this );
      var oembed = $button.data( 'oembed' );
      $modal.attr( 'aria-labelledby', $button.attr( 'id' ) );
      loadEmbed( $modal.find( '.modal-body' ), oembed );
    } );

    $doc.on( 'hidden.bs.modal', '.modal-oembed', function () {
      $( this ).find( 'iframe' ).removeAttr( 'src' );
    } );


    // Fetch all the forms we want to apply custom validation styles to
    $doc.on( 'submit', '.needs-validation', function ( e ) {
      if ( !this.checkValidity() ) {
        e.preventDefault();
        e.stopPropagation();
        const el = document.querySelector( '.needs-validation :invalid' );
        if ( el ) {
          goTo( el, 'smooth', getOffset( 100 ), function () {
            el.focus();
          } );
        }
      }
      $( this ).addClass( 'was-validated' );
    } );


  }


  /**
   * Setup sliders
   */
  const setupFilters = function () {

    const $tag_filter = $( '.form-track-filters .js-select2' );

    $tag_filter.select2( {
      language: themeData.lang
    } );

    $tag_filter.on( 'change', function ( e ) {
      console.log( $( this ).val() );
      $( this ).closest( 'form' ).trigger( 'submit' );
    } );

  }


  /**
   * Setup sliders
   */
  const setupSliders = function () {

    // Swiper sliders
    const heroSlider = new Swiper( '.u2f-hero-slider', {
      ...sliderSettings,
      effect: 'fade',
      /*fadeEffect: {
        crossFade: true
      },*/
    } );


    const gallerySlider = new Swiper( '.u2f-gallery-slider', {
      ...sliderSettings,
      autoplay: false,
      loop: false,
      watchSlidesVisibility: true,
      /*preloadImages: false,
      lazy: {
        loadPrevNext: true,
        loadPrevNextAmount: 1,
        loadOnTransitionStart: true
      },*/
      updateOnWindowResize: true,
      slidesPerView: 1,
      spaceBetween: 40,
      breakpoints: {
        540: {
          slidesPerView: 'auto',
        },
      },
      on: {
        beforeResize () {
          if ( window.innerWidth >= 540 ) {
            gallerySlider.slides.css( 'width', '' );
          }
        }
      }
    } );



  }

  /**
   * Setup galleries
   */
  const setupGalleries = function () {

    // default fancybox config
    $( '[data-fancybox]' ).fancybox( {
      ...fancySettings
    } );

    // gallery slider fancybox config
    /*$('[data-fancybox^="gallery-"]').fancybox({
      ...fancySettings,
      loop: false,
      backFocus: false
    });*/

  }


  /**
   * Set object fit image 
   * @param {object} img image object
   * @returns 
   */
  /*const fitThumb = function ( img ) {

    if ( !img ) return false;

    const $img = $( img );
    const w = img.naturalWidth;
    const h = img.naturalHeight;

    $img.addClass( 'show' );

    if ( !w || !h ) return false;

    if ( w < $img.parent().width() || h < $img.parent().height() ) {
      $img.addClass( 'contain' );
    } else {
      $img.removeClass( 'contain' );
    }

  }*/

  /**
   * Position and Fade In image thumbnails after load complete
   */
  const preloadThumbs = function () {
    $( ".img-cover.fade:not(.show),.img-fluid.fade:not(.show)" ).on( "load", function () {
      //fitThumb( this );
      $( this ).addClass( 'show' );
    } ).each( function () {
      // forze for cached images
      if ( this.complete ) $( this ).trigger( "load" );
    } );
  }


  /**
   * Load oembed videos
   */
  const loadEmbed = function ( $container, oembed ) {
    var $iframe = $( oembed );
    var src = $iframe.find( 'iframe' ).data( 'src' );
    var $modal_iframe = $( $iframe.html() );
    $modal_iframe.find( 'iframe' ).attr( 'src', src );
    $container.html( $modal_iframe );
  }


  /**
   * Initialize application
   */
  $( function () {
    console.log( '🚀 UOC2Future is ready!' );
    if ( isMobile.any() ) $body.addClass( 'device-touch' );
    objectFitImages( 'img.img-cover' );
    setupMenu();
    setupEvents();
    setupFilters();
    setupSliders();
    setupGalleries();

    preloadThumbs();
    onResize();
    onScroll();
  } )

} )( jQuery, typeof uoc2futureData !== 'undefined' ? uoc2futureData : {} );